import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeadersForOrganisation } from "./apiHelpers";

const endpoint = spellbook("/v1/feedback/organisation/{organisationId}/sider/{siderId}").POST();

export type PostFeedbackPathParams = typeof endpoint.types.P;
export type PostFeedbackReq = typeof endpoint.types.Req;
export type PostFeedbackResponse = typeof endpoint.types.Res;

type PostFeedbackInput = {
    organisationId: string;
    siderId: string;
    data: {
        taskId: string;
        typeId?: string;
        managerId: string;
        pro: number;
        perf: number;
        comment: string;
    };
};

function buildPostFeedbackReq(args: PostFeedbackInput): PostFeedbackReq {
    const { organisationId, siderId, data } = args;
    const logasId =
        typeof localStorage !== `undefined`
            ? (localStorage.getItem(`side_team_logasId`) ?? ``)
            : ``;
    const base = {
        taskId: data.taskId,
        organisationId,
        logasId,
        managerId: data.managerId,
        siderId,
        comment: data.comment ?? ``,
        pro: data.pro,
        perf: data.perf,
    };
    if (data.typeId) {
        return { ...base, typeId: data.typeId };
    }
    return base;
}

export async function postFeedback(params: PostFeedbackInput): Promise<PostFeedbackResponse> {
    const organisationId = params.organisationId?.trim();
    if (!organisationId) {
        throw new Error(
            `postFeedback: missing organisationId (URL would be .../organisation//sider/...).`,
        );
    }
    const call = createCall(endpoint, (r) =>
        fetch(withAccountOrNetworkAuthHeadersForOrganisation(r, organisationId)),
    );
    const req = buildPostFeedbackReq({ ...params, organisationId });
    return await call({
        params: { organisationId, siderId: params.siderId },
        req,
    });
}
